/* eslint-disable */
import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
'use strict';

const SplideExample = {
	init: function() {
		if (!document.querySelector('.splide')) {
			return;
		}
		const teamBlock = document.querySelectorAll('.team-block');
		const asSeenIn = document.querySelector('.as-seen-in');
		const shopByNeed = document.querySelector('.shop-by-need');
		const shopBestsellers = document.querySelector('.shop-bestsellers');
		const singleProduct = document.querySelector('.product-single');
		const singleProductTestimonials = document.querySelector('.product-single__left-testimonials');
		const quote = document.querySelector('.quote');
		const reviews = document.querySelector('.reviews');
		const latestAricles = document.querySelector('.latest-articles');
		const ugc = document.querySelector('.ugc');
		const storiesTwoColumns = document.querySelector('.stories-two-columns');

		if (window.innerWidth < 992) {
			
			if (latestAricles) {
				this.latestArticlesSlider();
			}
		}

		if (window.innerWidth < 768) {

			if (teamBlock) {
				this.teamMembersSlider();
			}

			if (ugc) {
				this.ugcSlider();
			}
			
			if (asSeenIn) {
				this.asSeenInSlider();
			}
			
			if (shopBestsellers) {
				this.shopBestsellersSlider();
			}
		}
		if (window.innerWidth < 576) {

			if(storiesTwoColumns) {
				this.storiesTwoColumnsSlider();
			}
		}

		if(shopByNeed) {
			this.shopByNeedSlider();
		}

		if (singleProduct) {
			this.singleProductSlider();
		}
		if (singleProductTestimonials) {
			this.singleProductTestimonials();
		}
		if(reviews) {
			this.reviewsSlider();
		}
		setTimeout(() => {
            this.singleProductTestimonialsAppendArrows();
			this.reviewsSliderAppendArrows();
        }, 300);
		if(quote) {
			this.quoteSlider();
			this.quoteAppendArrows();
		}
	},

	teamMembersSlider() {
		const teamSlider = document.querySelectorAll('.team-slider');
		teamSlider.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 2,
				focus: 0,
				gap: 24,
				pagination: true,
				arrows: true,
				breakpoints: {
					400: {
						perPage: 1,
						gap: 16,
					}
				},
			});

			main.mount();
    	});
	},

	asSeenInSlider() {
		const asSeenInSlider = document.querySelectorAll('.as-seen-in__boxes-wrap');
		asSeenInSlider.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 3,
				rewind: false,
				focus: 0,
				gap: 10,
				arrows: false,
				pagination: false,
				pauseOnHover: false,
				breakpoints: {
					400: {
						perPage: 3,
					}
				}
			});
			
			main.mount( { AutoScroll } );
	
			// Move to the first slide immediately
			main.go(1);
		});
	},	

	shopByNeedSlider() {
		const shopByNeed = document.querySelectorAll('.shop-by-need__boxes-slider');
		shopByNeed.forEach(function (slider) {
			let main = new Splide(slider, {
				
				perPage: 5,
				rewind: false,
				//focus: 0,
				gap: 16,
				autoWidth: false,
				pagination: false,
				arrows: false,
				trimSpace: true,
				breakpoints: {
					1919: {
						type: 'slide',
						perPage: 6,
						rewind: false,
						focus: 0,
						gap: 16,
						// autoWidth: true,
						pagination: false,
						arrows: false
					},
					575: {
						type: 'loop',
						perPage: 1,
						gap: 0,
						pagination: true,
						arrows: true,
						autoWidth: false,
						grid: {
							dimensions: [ [ 2, 2 ] ],
							gap: {
								row: '15px',
								col: '16px',
							},
						},
					},
				},
			});
			document.querySelector('#shop-by-need-arrowNext').addEventListener('click', e => {
				main.go('+1')
			})
			
			document.querySelector('#shop-by-need-arrowPrev').addEventListener('click', e => {
				main.go('-1')
			})

			main.mount({ Grid });

			main.on( 'move', function () {
				const splideRoot = slider.closest('.shop-by-need__boxes');
			if (main.index === 0) {
				splideRoot.classList.add('shop-by-need__boxes--fade-left');
			} else {
				splideRoot.classList.remove('shop-by-need__boxes--fade-left');
			}
			
			if (main.index === main.Components.Controller.getEnd()) {
				splideRoot.classList.add('shop-by-need__boxes--fade-right');
			} else {
				splideRoot.classList.remove('shop-by-need__boxes--fade-right');
			}
			} );
    	});
	},

	shopBestsellersSlider() {
		const teamSlider = document.querySelectorAll('.js-shop-bestsellers-slider');
		teamSlider.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 2,
				focus: 0,
				gap: 24,
				pagination: false,
				arrows: false,
				breakpoints: {
					575: {
						perPage: 1,
						gap: 32,
					}
				},
			});

			main.mount();
    	});
	},

	singleProductSlider() {
		const isMobile = window.innerWidth < 992;
		let thumbnailSliderElement = document.querySelector('.single-product__image-thumbnail-splide');
    	let thumbnailSlides = document.querySelectorAll('.single-product__image-thumbnail-list');
		if (thumbnailSlides.length < 5) {
			thumbnailSliderElement.classList.add('less-then-5');
		}
		let main = new Splide('.single-product__image-main-splide', {
			type: 'slide',
			perPage: 1,
			perMove: 1,
			rewind: true,
			pagination: false,
			arrows: true,
			breakpoints: {
				991: {
					arrows: false,
					pagination: true,
					rewind: false,
					perPage: 1,
					padding: { right: '20%' },
					gap: 12,
				},
			},
		});

		if (!isMobile) {
			let thumbnails = new Splide('.single-product__image-thumbnail-splide', {
				perPage: 5,
				perMove: 1,
				rewind: true,
				arrows: false,
				isNavigation: true,
				gap: 16,
				pagination: false,
				cover: false,
				dragMinThreshold: {
					mouse: 4,
					touch: 10,
				},
			});
			main.sync(thumbnails);
			main.mount();
			thumbnails.mount();
		} else {
			main.mount();
		}

		main.on('move', (newIndex) => {
			let zoomTrigger = document.querySelector('.js-zoom-modal-pdp');
			if (zoomTrigger) {
				zoomTrigger.setAttribute('data-current-index', newIndex);
			}
		});
	},

	singleProductTestimonials() {
		const singleProductTestimonials = document.querySelectorAll('.product-single__left-testimonials-slider');
		singleProductTestimonials.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 1,
				rewind: false,
				focus: 0,
				gap: 16,
				pagination: true,
				arrows: true,
			});
			main.mount();
    	});
	},

	singleProductTestimonialsAppendArrows() {
		const parentElement = document.querySelector('.product-single__left-testimonials-slider .splide__pagination');
		const childElement = document.querySelector('.product-single__left-testimonials-slider .splide__arrows');
	
		if (parentElement && childElement) {
			parentElement.appendChild(childElement); 
		}
	},

	quoteSlider() {
		let main = new Splide('.js-quote-slider__left-slider', {
			type   : 'loop',
			perPage: 1,
			// perMove: 1,
			rewind: true,
			pagination: true,
			arrows: true,
			speed: 0,
			rewindSpeed: 100,
		});
		let images = new Splide('.js-quote-slider__right-slider', {
			type   : 'loop',
			perPage: 3,
			// perMove: 1,
			// rewind: true,
			focus: 0,
			arrows: false,
			isNavigation: true,
			variableWidth: false,
			gap: 24,
			pagination: false,
			speed: 0,
			rewindSpeed: 100,
			breakpoints: {
				1024: {
					loop: false,
				},
				575: {
					perPage: 2,
					gap: 16,
				},
				400: {
					perPage: 1,
					gap: 16,
				},
			},
		});
		main.sync(images);
		main.mount();
		images.mount();

		main.on('moved', function() {
			document.querySelector('.quote-slider__right').classList.remove('has-padding');
		});
		images.on('moved', function() {
			document.querySelector('.quote-slider__right').classList.remove('has-padding');
		});
	},

	quoteAppendArrows() {
		const parentElement = document.querySelector('.js-quote-slider__left-slider .splide__pagination');
		const childElement = document.querySelector('.js-quote-slider__left-slider .splide__arrows');
	
		if (parentElement && childElement) {
			parentElement.appendChild(childElement); 
		}
	}, 

	reviewsSlider() {
		const reviews = document.querySelectorAll('.js-reviews-bottom__slider');
		reviews.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 3,
				rewind: false,
				focus: 0,
				gap: 32,
				pagination: true,
				arrows: true,
				breakpoints: {
					991: {
						perPage: 2,
					},
					767: {
						perPage: 1,
					}
				},
			});
			main.mount();
			const slides = document.querySelectorAll('.js-reviews-bottom__slider .splide__slide:not(.splide__slide--clone)');
			if(slides.length <= 3) {
				reviews.forEach(function (slider) {
					slider.classList.add('desk-3-or-less');
				});
			}
    	});
	},

	reviewsSliderAppendArrows() {
		const parentElement = document.querySelector('.js-reviews-bottom__slider .splide__pagination');
		const childElement = document.querySelector('.js-reviews-bottom__slider .splide__arrows');
	
		if (parentElement && childElement) {
			parentElement.appendChild(childElement); 
		}
	},

	latestArticlesSlider() {
		const latestArticles = document.querySelectorAll('.js-latest-articles__slider');
		latestArticles.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 2,
				perMove: 1,
				focus: 0,
				gap: 24,
				pagination: true,
				arrows: true,
				variableWidth: false,
				breakpoints: {
					767: {
						perPage: 1,
						gap: 32,
					}
				},
			});

			main.mount();
    	});
	},

	ugcSlider() {
		const ugcSlider = document.querySelectorAll('.ugc-slider');
		ugcSlider.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 2,
				focus: 0,
				gap: 24,
				pagination: true,
				arrows: true,
				breakpoints: {
					576: {
						perPage: 1,
						gap: 15,
					}
				},
			});
			main.mount();
    	});
	},

	storiesTwoColumnsSlider() {
		const storiesTwoColumnsSlider = document.querySelectorAll('.stories-two-columns-slider');
		storiesTwoColumnsSlider.forEach(function (slider) {
			let main = new Splide(slider, {
				type: 'loop',
				perPage: 1,
				focus: 0,
				gap: 32,
				pagination: true,
				arrows: true,
			});
			main.mount();
    	});
	},

};

export default SplideExample;